import {ICON_TYPES} from '../constants';

export const LocationIcon = () => {
  return (
    <svg
      width='13'
      height='15'
      viewBox='0 0 13 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.47375 15.0048L6.03808 14.6314C5.43746 14.1285 0.193115 9.59926 0.193115 6.28625C0.193115 2.81756 3.00506 0.00561523 6.47375 0.00561523C9.94244 0.00561523 12.7544 2.81756 12.7544 6.28625C12.7544 9.59929 7.51004 14.1285 6.91191 14.6339L6.47375 15.0048ZM6.47375 1.36367C3.75638 1.36675 1.55428 3.56885 1.5512 6.28622C1.5512 8.36753 4.77772 11.6924 6.47375 13.2141C8.1698 11.6918 11.3963 8.36501 11.3963 6.28622C11.3932 3.56885 9.19115 1.36678 6.47375 1.36367Z'
        fill='#43494F'
      />
      <path
        d='M6.47372 8.77557C5.09876 8.77557 3.98413 7.66094 3.98413 6.28598C3.98413 4.91102 5.09876 3.79639 6.47372 3.79639C7.84868 3.79639 8.96331 4.91102 8.96331 6.28598C8.96331 7.66094 7.84871 8.77557 6.47372 8.77557ZM6.47372 5.04115C5.78624 5.04115 5.22893 5.59847 5.22893 6.28595C5.22893 6.97343 5.78624 7.53074 6.47372 7.53074C7.1612 7.53074 7.71852 6.97343 7.71852 6.28595C7.71852 5.59847 7.16123 5.04115 6.47372 5.04115Z'
        fill='#43494F'
      />
    </svg>
  );
};

LocationIcon.iconType = ICON_TYPES.LOCATION;
